import get from 'lodash/get';
import { trackGAEvent } from '../client/utils/third_party_trackers/ga';

export default function sendGASubscriptionEvents(arr, newsletters) {
  if (Array.isArray(arr) || Object.keys(newsletters || {}).length !== 0) {
    arr.forEach(function iterateThroughListIds(listId) {
      const nlGroup = get(
        Object.keys(newsletters).filter(function findCurrentNlGroup(nl) {
          return get(newsletters, `[${nl}].listId`) === listId;
        }),
        [0]
      );
      trackGAEvent({
        eventCategory: 'Newsletter Signup',
        eventAction: 'subscribe',
        eventLabel: get(newsletters, `[${nlGroup}].listName`)
      });
    });
  }
}
